// eslint-disable-next-line
import axios, { isAxiosError } from "axios";
import Cookies from "js-cookie";

axios.defaults.baseURL = "http://thecharmingtreasure.in:4000/api/billing/";
axios.defaults.headers.common["Authorization"] = Cookies.get("auth-token");
export default axios;
